import Vue from 'vue';
import {
    getCategory,
    getBrand,
    getSubbrand,
    getForm,
    getVariant,
    getSize,
    getCustomerChannel,
    getFactbookMedia
} from '@/api/system';

export default Vue.extend({
    data() {
        return {
            value: '',
            column: ''
        };
    },
    created() {
        this.value = this.params.value;
    },
    mounted() {
        Vue.nextTick(() => {
            // need to check if the input reference is still valid - if the edit was cancelled before it started there
            // wont be an editor component anymore
            if (this.$refs.input) {
                this.$refs.input.focus();
                if (this.params.keyPress === 46) {
                    this.value = null;
                } else if (this.params.charPress === null) {
                    this.value = this.params.value;
                } else if (this.value === null) {
                    this.value = this.params.charPress;
                } else {
                    this.value = this.value ?
                        this.value.toString() + this.params.charPress :
                        this.params.charPress;
                }
            }
        });
    },
    methods: {
        querySearchAsync(queryString, cb) {
            const category =
                this.params.node.data.category &&
                this.params.node.data.category.trim();
            const planCountry = sessionStorage.getItem('planCountry');
            const runratetype =
                this.params.node.data.runrateSource &&
                this.params.node.data.runrateSource.trim();
            const brand = this.params.node.data.brand ?
                this.params.node.data.brand.trim() :
                '';
            const subbrand = this.params.node.data.subbrand ?
                this.params.node.data.subbrand.trim() :
                '';
            const form = this.params.node.data.form ?
                this.params.node.data.form.trim() :
                '';
            const variant = this.params.node.data.variant ?
                this.params.node.data.variant.trim() :
                '';
            const size = this.params.node.data.size ?
                this.params.node.data.size.trim() :
                '';
            const channel = this.params.node.data.channel ?
                this.params.node.data.channel.trim() :
                '';
            const customer = this.params.node.data.customer ?
                this.params.node.data.customer.trim() :
                '';
            const obj = {
                country: planCountry,
                category: category,
                brand: brand,
                subbrand: subbrand,
                form: form,
                variant: variant,
                size: size,
                channel: channel,
                customer: customer,
                filterValue: queryString.trim(),
                planType: sessionStorage.getItem('planType')
            };

            if (
                JSON.parse(sessionStorage.getItem('userRole')).includes('ABM')
            ) {
                switch (this.column) {
                    case 'category':
                        getCategory(planCountry, queryString.trim()).then(
                            res => {
                                cb(res.data.data);
                            }
                        );
                        break;
                    case 'brand':
                        getBrand(
                            planCountry,
                            category,
                            queryString.trim()
                        ).then(res => {
                            cb(res.data.data);
                        });
                        break;
                    case 'subbrand':
                        getSubbrand(
                            planCountry,
                            category,
                            queryString.trim()
                        ).then(res => {
                            cb(res.data.data);
                        });
                        break;
                    case 'form':
                        getForm(planCountry, category, queryString.trim()).then(
                            res => {
                                cb(res.data.data);
                            }
                        );
                        break;
                    case 'variant':
                        getVariant(
                            planCountry,
                            category,
                            queryString.trim()
                        ).then(res => {
                            cb(res.data.data);
                        });
                        break;
                    case 'size':
                        getSize(planCountry, category, queryString.trim()).then(
                            res => {
                                cb(res.data.data);
                            }
                        );
                        break;
                    case 'channelCustomer':
                        getCustomerChannel(
                            planCountry,
                            category,
                            runratetype,
                            queryString.trim()
                        ).then(res => {
                            cb(res.data.data);
                        });
                        break;
                    case 'touchPoint':
                        getFactbookMedia(obj).then(res => {
                            const result = [];

                            res.data.data.forEach(element => {
                                result.push({
                                    value: element.topicName
                                });
                            });
                            cb(result);
                        });
                        break;
                    case 'promoConfig':
                        getFactbookMedia(obj).then(res => {
                            const result = [];

                            res.data.data.forEach(element => {
                                result.push({
                                    value: element.topicName
                                });
                            });
                            cb(result);
                        });
                        break;
                    case 'salesFundamental':
                        getFactbookMedia(obj).then(res => {
                            const result = [];

                            res.data.data.forEach(element => {
                                result.push({
                                    value: element.topicName
                                });
                            });
                            cb(result);
                        });
                        break;
                    case 'benchMarkActivity':
                        getFactbookMedia(obj).then(res => {
                            const result = [];

                            res.data.data.forEach(element => {
                                result.push({
                                    value: element.topicName
                                });
                            });
                            cb(result);
                        });
                        break;
                    case 'type':
                        getFactbookMedia(obj).then(res => {
                            const result = [];

                            res.data.data.forEach(element => {
                                result.push({
                                    value: element.topicName
                                });
                            });
                            cb(result);
                        });
                        break;
                    default:
                        break;
                }
            }
        },
        onFocus() {
            this.column = this.params.api.getEditingCells()[0].column.colId;
        },
        handleSelect(item) {
            this.value = item.value;
        },
        onChange() {
            this.value === '' ? null : this.value;
        },
        getValue() {
            return this.value === '' ? null : this.value;
        }
    },
    template: `
        <el-autocomplete
            v-model="value"
            :trigger-on-focus="false"
            :fetch-suggestions="querySearchAsync"
            @select="handleSelect"
            @focus="onFocus"
            @keyup.native="onChange"
            :ref="'input'"
        ></el-autocomplete>
    `
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/autoComplete.js